// extracted by mini-css-extract-plugin
export default {"icon":"SVGIcons_icon__R44zV"};